import React, { useEffect, useState } from 'react';
import { Collapse } from '@material-ui/core';
import './LandingPage.scss';
// import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import { makeStyles } from '@material-ui/core/styles';

// const useStyles = makeStyles((theme) => ({
//   iconButton: {
//     fontSize: 40,
//     color: 'white',
//     padding: '20px',
//   },
//   fab: {
//     marginBottom: '20px',
//   },
// }));
const LandingPage = () => {
  // const classes = useStyles();
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    setChecked(true);
  }, []);
  return (
    <div className="landing-page">
      <div className="hero">
        <div className="landing-logo">
          <a href="/">
            <img className="brand" src="/images/logo-white.png" alt="logo" width="150" />
          </a>
          <div className="menu-spacer"></div>
          <div className="landing-menu">
            <div className="top-link-container">
              <a href="/about" className="top-link">
                About Us
              </a>
            </div>
          </div>
        </div>
        <div className="landing-container">
          <div className="welcome-text">
            <Collapse
              in={checked}
              style={{ transformOrigin: '0 0 0' }}
              {...(checked ? { timeout: 1000 } : {})}
            >
              <p className="title">
                Welcome to <br /> Natura Alert
              </p>
              <p className="join-text">Join the Citizen Science movement!</p>
              <p className="tagline">
                Report threats to protected nature sites and help volunteers track changes to biodiversity.
              </p>
              <div className="links">
                <a href="/explore" className="link link-primary">
                  <img src="/images/web-site.png" alt="" />
                  <span>Explore the map</span>
                </a>
                <a
                  href="https://discord.gg/XNFAfNJ5BQ"
                  className="link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="/images/discord.svg" alt="" />
                  <span>Join the community</span>
                </a>
              </div>
            </Collapse>
          </div>

          {/* <Fab color="secondary" aria-label="" className={classes.fab}>
            <ExpandMoreIcon className={classes.iconButton} />
          </Fab> */}
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
